"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_MORE_META = exports.GALLERY = void 0;
const GALLERY = exports.GALLERY = 'gallery';
const LOAD_MORE_META = exports.LOAD_MORE_META = ['Olapic', 'Gallery load more'];
